import { render } from "./GenericProgram.vue?vue&type=template&id=2dcc53d3"
import script from "./GenericProgram.vue?vue&type=script&lang=js"
export * from "./GenericProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__